export default __webpack_public_path__ + "static/media/co-lab.5b340d27.png";